/* AFO Wishlist — heart on product cards (collections, search, featured collections, recommendations).
   Upload as assets/afo-wishlist-cards.js and load it AFTER afo-wishlist.js in theme.liquid. */
(function () {
  if (window.__afoWlCards) return;
  window.__afoWlCards = true;

  const CARD_SEL = 'product-card, .product-card, .card-wrapper, .card-product, .grid__item, li';
  const HEART = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 8 3.3 4.5 6.8 4.5c2 0 3.5 1.1 4.2 2.3l1 1.6 1-1.6c.7-1.2 2.2-2.3 4.2-2.3 3.5 0 5.4 3.5 4.1 6.8-1.8 4.6-9.3 9.2-9.3 9.2z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';

  // AFO brand: charcoal outline when empty, burgundy (#802831) when saved or hovered
  const css = document.createElement('style');
  css.textContent = `
    .afo-wlc-host { position: relative; }
    .afo-wlc-heart {
      position: absolute; top: 10px; left: 10px; z-index: 3;
      width: 38px; height: 38px; border-radius: 50%;
      display: inline-flex; align-items: center; justify-content: center;
      background: rgba(255,255,255,.92); color: #1A1A1A;
      border: 0; padding: 0; cursor: pointer;
      box-shadow: 0 1px 4px rgba(0,0,0,.12);
      transition: transform .15s ease, color .15s;
    }
    .afo-wlc-heart:hover { transform: scale(1.06); color: #802831; }
    .afo-wlc-heart:focus-visible { outline: 2px solid #802831; outline-offset: 2px; }
    .afo-wlc-heart[aria-pressed="true"] { color: #802831; }
    .afo-wlc-heart[aria-pressed="true"] svg path { fill: currentColor; }
    @media (max-width: 749px) { .afo-wlc-heart { width: 34px; height: 34px; top: 8px; left: 8px; } }
    @media (prefers-reduced-motion: reduce) { .afo-wlc-heart { transition: none; } }

    /* "Saved to your wishlist · View" confirmation */
    .afo-wlc-toast {
      position: fixed; left: 50%; bottom: 24px; z-index: 2147483000;
      transform: translate(-50%, 16px); opacity: 0; pointer-events: none;
      display: flex; align-items: center; gap: 14px;
      max-width: calc(100vw - 32px); box-sizing: border-box;
      padding: 12px 14px 12px 16px; border-radius: 14px;
      background: #1A1A1A; color: #fff;
      font-size: 14px; line-height: 1.3;
      box-shadow: 0 12px 32px rgba(0,0,0,.28);
      transition: opacity .2s ease, transform .2s ease;
    }
    .afo-wlc-toast.is-open { opacity: 1; transform: translate(-50%, 0); pointer-events: auto; }
    .afo-wlc-toast svg { width: 18px; height: 18px; flex: 0 0 auto; color: #F2B8BE; }
    .afo-wlc-toast svg path { fill: currentColor; }
    .afo-wlc-toast__text { white-space: nowrap; }
    .afo-wlc-toast a {
      flex: 0 0 auto; padding: 8px 14px; border-radius: 999px;
      background: #802831; color: #fff !important; font-weight: 600; text-decoration: none;
    }
    .afo-wlc-toast a:hover { filter: brightness(1.12); }
    /* Phones: sit above the chat bubble */
    @media (max-width: 749px) { .afo-wlc-toast { bottom: 88px; } }
    @media (prefers-reduced-motion: reduce) { .afo-wlc-toast { transition: none; } }
  `;
  document.head.appendChild(css);

  let toastEl, toastTimer;
  function showToast() {
    const url = window.AFO_WISHLIST_URL || '/pages/wishlist';
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'afo-wlc-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
      toastEl.addEventListener('mouseenter', () => clearTimeout(toastTimer));
      toastEl.addEventListener('mouseleave', () => { toastTimer = setTimeout(hideToast, 2000); });
    }
    toastEl.innerHTML = HEART + '<span class="afo-wlc-toast__text">Saved to your wishlist</span><a href="' + url + '">View</a>';
    clearTimeout(toastTimer);
    requestAnimationFrame(() => toastEl.classList.add('is-open'));
    toastTimer = setTimeout(hideToast, 4000);
  }
  function hideToast() { if (toastEl) toastEl.classList.remove('is-open'); }

  function handleFrom(href) {
    const m = href && href.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function paint(btn) {
    const saved = AFOWishlist.has(btn.dataset.handle);
    btn.setAttribute('aria-pressed', saved);
    btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
  }

  function decorate() {
    if (!window.AFOWishlist) return;
    document.querySelectorAll('a[href*="/products/"]').forEach(link => {
      if (link.closest('.afo-wl, .afo-wlp, .afo-wlc-heart, header, nav, .header, footer')) return;
      const card = link.closest(CARD_SEL);
      if (!card || card.dataset.afoWl) return;
      const handle = handleFrom(link.getAttribute('href'));
      if (!handle) return;
      // Only decorate real cards (they have an image)
      const img = card.querySelector('img');
      if (!img) return;

      card.dataset.afoWl = '1';
      card.classList.add('afo-wlc-host');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'afo-wlc-heart';
      btn.dataset.handle = handle;
      btn.innerHTML = HEART;
      btn.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation();
        AFOWishlist.toggle(handle);
        paint(btn);
        if (AFOWishlist.has(handle)) showToast(); else hideToast();
      });
      paint(btn);
      card.appendChild(btn);
    });
  }

  function repaintAll() {
    document.querySelectorAll('.afo-wlc-heart').forEach(paint);
  }

  // Initial + re-run when Horizon re-renders grids (filters, sorting, infinite scroll, drawers)
  let t;
  const schedule = () => { clearTimeout(t); t = setTimeout(decorate, 80); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorate);
  else decorate();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('afo:wishlist', repaintAll);
})();